module.exports = __webpack_public_path__ + "img/arrow-square-up.fa630f9c.svg";